import { FunctionComponent } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as AstronomicLogo } from '../../../asset/images/astronomic_logo_2.svg';
import { ReactComponent as CdLogo } from '../../../apps/constellationDinners/asset/images/constellation_dinners_logo.svg';
import PopUp from '../PopUp/PopUp';
import styles from './AppsSelectorPopUp.module.scss';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { RoutesGrouped } from '../../../data/routes';
import RoutesEnum from '../../../enums/routes';

interface AppsSelectorPopUpProps {
  active: boolean;
  setActive(state: boolean): void;
}

const AppsSelectorPopUp: FunctionComponent<AppsSelectorPopUpProps> = ({ active, setActive }) => {
  const handleOnClose = () => setActive(false);

  return (
    <>
      {createPortal(
        <PopUp className={styles['pop-up']} active={active} onPopUpStateChange={setActive} popUpWidth="720">
          <ul className={styles['pop-up__list']}>
            <li>
              <NavLink className={styles['pop-up__list__item']} to={`/${RoutesEnum.ACCOUNT}`} onClick={handleOnClose}>
                <div className={styles['pop-up__list__item__logo']}>
                  <AstronomicLogo />
                </div>

                <p className={classNames(styles['pop-up__list__item__text'], 'text text--body-3')}>Astronomic</p>
              </NavLink>
            </li>

            <li>
              <NavLink
                className={styles['pop-up__list__item']}
                to={`/${RoutesGrouped.CONSTELLATION_DINNERS_BASE}`}
                onClick={handleOnClose}
              >
                <div className={styles['pop-up__list__item__logo']}>
                  <CdLogo />
                </div>

                <p className={classNames(styles['pop-up__list__item__text'], 'text text--body-3')}>
                  Constellation Dinners
                </p>
              </NavLink>
            </li>
          </ul>
        </PopUp>,
        document.getElementById('modal') as HTMLElement
      )}
    </>
  );
};

export default AppsSelectorPopUp;
